import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollMemory = props => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(props.x, props.y);
  }, [pathname]);
  
  return null;
}
export default ScrollMemory;